// Laravel public-диск: публичные URL файлов и форматирование объёмов
// аудио-хранилища учителя (единицы измерения — в i18n-ключах на месте использования).

import i18n from '@/i18n/config'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:4545/api'

const BYTES_IN_MB = 1024 * 1024

/** Порог, с которого занятое место подсвечивается предупреждением */
export const STORAGE_WARNING_PERCENT = 80

/**
 * Байты → мегабайты строкой в текущей локали (разделители разрядов и дробной
 * части). До 0.1 МБ — две десятых («0,04»), чтобы небольшие файлы не
 * показывались как «0».
 */
export function bytesToMb(bytes: number): string {
  const mb = bytes / BYTES_IN_MB
  const maximumFractionDigits = mb > 0 && mb < 0.1 ? 2 : 1

  return new Intl.NumberFormat(i18n.language === 'en' ? 'en-US' : 'ru-RU', {
    maximumFractionDigits,
  }).format(mb)
}

/**
 * Доля занятого места в процентах (0–100).
 * Безлимит (null) — 0; нулевой лимит — всегда 100 %: пользователь заблокирован,
 * и полоса не должна выглядеть как «места полно» даже при пустом хранилище.
 */
export function storagePercent(usedBytes: number, limitBytes: number | null): number {
  if (limitBytes === null) {
    return 0
  }
  if (limitBytes <= 0) {
    return 100
  }
  return Math.min(100, (usedBytes / limitBytes) * 100)
}

function getApiOrigin(): string {
  return API_URL.replace(/\/api\/?$/, '').replace(/\/$/, '')
}

/**
 * Публичный URL файла из Laravel storage (диск public, symlink /storage).
 * Строим от origin API (VITE_API_URL), т.к. APP_URL на бэкенде может быть без порта.
 */
export function storagePublicUrl(pathOrUrl: string | null | undefined): string {
  if (!pathOrUrl) return ''

  if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
    try {
      const parsed = new URL(pathOrUrl)
      if (parsed.pathname.startsWith('/storage/')) {
        return `${getApiOrigin()}${parsed.pathname}`
      }
    } catch {
      return pathOrUrl
    }
    return pathOrUrl
  }

  const path = pathOrUrl.replace(/^\/+/, '').replace(/^storage\//, '')
  return `${getApiOrigin()}/storage/${path}`
}
